import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgChevronRightIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 4L10 8L6 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
});
export default SvgChevronRightIcon;
